import * as z from 'zod';
import { ReservationEmailType } from './ReservationSentEmail';
// Mirrors ReservableProductEmailStatus on the server
export const ReservableProductEmailStatus = z.enum(['sent', 'partially_sent', 'not_sent']);
// Mirrors ReservableProductEmailMoment on the server
export const ReservableProductEmailMoment = z.enum(['booked', 'start', 'check_in', 'end']);
// Mirrors ReservableProductEmailReason on the server
export const ReservableProductEmailReason = z.enum([
    'check_in_by_staff',
    'no_access_code',
    'only_some_reservables_have_locks',
    'check_out_by_staff',
    'check_out_automatic'
]);
/**
 * När ett reservationsmejl skickas för produktens reservationer, och om produktens
 * inställningar stoppar det. Servern räknar fram det med samma regler som när mejlen skickas.
 */
export const ReservableProductEmail = z.object({
    type: ReservationEmailType,
    status: ReservableProductEmailStatus,
    moment: ReservableProductEmailMoment,
    /** Hur långt före `moment` mejlet skickas, 0 för just då */
    minutes_before: z.int().nonnegative(),
    reason: ReservableProductEmailReason.nullable()
});
